import React, { memo } from 'react';
import cc from 'classcat';
import TextField from '../TextField';
import ClosingIcon from '../../assets/icons/closing-icon.svg';
import SearchIcon from '../../assets/icons/search-icon.svg';
import './search-field.style.scss';
/**
 * A search field component
 */
var SearchField = function (_a) {
    var onIconClick = _a.onIconClick, onChange = _a.onChange, value = _a.value, placeholder = _a.placeholder, className = _a.className;
    return (React.createElement("div", { className: cc(['tfm-search-field', className]) },
        React.createElement(TextField, { placeholder: placeholder, onChange: onChange, value: value, className: "tfm-search-field-padding" }),
        React.createElement("button", { type: "button", className: "tfm-search-field-button", "aria-label": "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7", onClick: onIconClick }, value ? (React.createElement(ClosingIcon, null)) : (React.createElement(SearchIcon, null)))));
};
export default memo(SearchField);
